import { useTranslation, Trans } from 'react-i18next';

import './presentation.css'

export default function Presentation() {

    const { t } = useTranslation();

    return (
        <div className="back-container-black relative pb-6 afterparralax">
            <h2 className="text-center titles text-300">{t("welcome")}</h2>

            <p className="text-center text-200 welcomeText select-none"><Trans i18nKey="presentation"/></p>
        </div>
    )

}